import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineRounded";
import ManageAccountsIcon from "@mui/icons-material/ManageAccountsRounded";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAltRounded";
import { IconButton, Tooltip } from "@mui/material";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { OrganizationMember } from "../../../../../api/types/userManagementTypes";
import MembersContext from "../MembersContext";

interface MemberRowActionsMenuProps {
  member: OrganizationMember;
  onSelected: (member: OrganizationMember | undefined) => void;
}

const MemberRowActionsMenu = ({ member, onSelected }: MemberRowActionsMenuProps) => {
  const { deactivateMembers, duplicateNewMembersFrom, manageAccess, isLoading, isCurrentUser } =
    useDefinedContext(MembersContext);

  const handleDeactivate = () => {
    deactivateMembers([member.userId]);
  };

  const handleDuplicate = () => {
    duplicateNewMembersFrom(member);
  };

  const handleManageAccess = () => {
    manageAccess(member);
  };

  const ManageRowButtonComponent = (
    <IconButton sx={{ mr: 0.5 }} disabled={isLoading} onClick={handleManageAccess}>
      <ManageAccountsIcon />
    </IconButton>
  );

  return (
    <>
      {isLoading ? (
        ManageRowButtonComponent
      ) : (
        <Tooltip placement="top" title="Manage access" arrow>
          {ManageRowButtonComponent}
        </Tooltip>
      )}
      <ActionsMenuButton
        onOpen={() => onSelected(member)}
        onClose={() => onSelected(undefined)}
        items={[
          {
            icon: <PersonAddAltIcon sx={{ color: "action.active" }} color="secondary" />,
            label: "New with the same access",
            onClick: handleDuplicate,
          },
          {
            icon: <ManageAccountsIcon sx={{ color: "action.active" }} />,
            label: "Manage access",
            onClick: handleManageAccess,
          },
          {
            icon: <DeleteOutlineIcon color="error" />,
            label: "Deactivate",
            onClick: handleDeactivate,
            disabled: isCurrentUser(member.email),
          },
        ]}
      />
    </>
  );
};

export default MemberRowActionsMenu;
